


document.addEventListener("DOMContentLoaded", (event) => {
const alternateProducts = () => {
let isDown = false;
let startX;
let scrollLeft;
const alternateProducts = document.querySelector('.team-members');
   
const end = () => {
	isDown = false;
}

const start = (e) => {
  isDown = true;
  startX = e.pageX || e.touches[0].pageX - alternateProducts.offsetLeft;
  scrollLeft = alternateProducts.scrollLeft;	
}

const move = (e) => {
	if(!isDown) return;

  e.preventDefault();
  const x = e.pageX || e.touches[0].pageX - alternateProducts.offsetLeft;
  const dist = (x - startX)*2;
   // Smooth scrolling using requestAnimationFrame
    requestAnimationFrame(() => {
      alternateProducts.scrollLeft = scrollLeft - dist;
    });
}

    if(alternateProducts) {
      alternateProducts.addEventListener('mousedown', start);
      alternateProducts.addEventListener('touchstart', start);
  
      alternateProducts.addEventListener('mousemove', move);
      alternateProducts.addEventListener('touchmove', move);
  
      alternateProducts.addEventListener('mouseleave', end);
      alternateProducts.addEventListener('mouseup', end);
      alternateProducts.addEventListener('touchend', end);
    }
	

    }
  // Init free gifts slider
    let matchMedia = window.matchMedia("(min-width:767px)");
    if(matchMedia.matches){
        alternateProducts();
    }
});

$(document).ready(function() {

    var backButton = '<span class="slick-prev"><svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.9531 13.2969L14.6656 17.4654C14.6096 17.5205 14.5781 17.5949 14.5781 17.6719C14.5781 17.7489 14.6096 17.8233 14.6656 17.8784L18.9531 22.0469" stroke="#747D87" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';
    var nextButton = '<span class="slick-next"><svg width="35" height="36" viewBox="0 0 35 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0469 13.2969L20.3344 17.4654C20.3904 17.5205 20.4219 17.5949 20.4219 17.6719C20.4219 17.7489 20.3904 17.8233 20.3344 17.8784L16.0469 22.0469" stroke="#747D87" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>'

    $('.gallery_mobile_wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        asNavFor: '.gallery_mobile_wrapper_thumbnail',
        prevArrow: backButton,
        nextArrow: nextButton
    });

    $('.gallery_mobile_wrapper_thumbnail').slick({
        asNavFor: '.gallery_mobile_wrapper',
        dots: false,
        arrows: false,
        infinite: true,
        slidesToShow: 5,
        centerMode: true,
        centerPadding: '45px',
        cssEase: 'ease-in-out',
        focusOnSelect: true
    });

    $(".shopify-section--video-carousel .video_slider.video_carousel").slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        responsive: [{
                breakpoint: 1250,
                settings: {
                    slidesToShow: 4,
                    arrows: false
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.1,
                    arrows: false
                }
            }
        ]
    });

    $(".arrow-btn-wrap .prev-btn").click(function() {
        $(".shopify-section--video-carousel .video_slider").slick("slickPrev");
    });

    $(".arrow-btn-wrap .next-btn").click(function() {
        $(".shopify-section--video-carousel .video_slider").slick("slickNext");
    });
    $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
    $(".shopify-section--video-carousel .video_slider").on("afterChange", function() {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .prev-btn").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .next-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .next-btn").removeClass("slick-disabled");
        }
    });

    $(".shopify-section-related-products .related_product_item_list").slick({
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        responsive: [          
           {
            breakpoint: 990,
             settings: { 
              slidesToShow: 2,
               slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: "unslick"
          }
        ]
    });

    $(".arrow-btn-wrap .prev-btn").click(function() {
        $(".shopify-section-related-products .related_product_item_list").slick("slickPrev");
    });

    $(".arrow-btn-wrap .next-btn").click(function() {
        $(".shopify-section-related-products .related_product_item_list").slick("slickNext");
    });
    $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
    $(".shopify-section-related-products .related_product_item_list").on("afterChange", function() {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .prev-btn").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .next-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .next-btn").removeClass("slick-disabled");
        }
    });

    $('.shopify-section--logo-list .section-spacing .logo-list').slick({
        infinite: false,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      prevArrow: "<button type='button' class='slick-prev pull-left video-slider-nav-btn'><svg width='35' height='36' viewBox='0 0 35 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M18.9531 13.2969L14.6656 17.4654C14.6096 17.5205 14.5781 17.5949 14.5781 17.6719C14.5781 17.7489 14.6096 17.8233 14.6656 17.8784L18.9531 22.0469' stroke='#747D87' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'></path></svg></button>",
        nextArrow: "<button type='button' class='slick-next pull-right video-slider-nav-btn'><svg width='35' height='36' viewBox='0 0 35 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16.0469 13.2969L20.3344 17.4654C20.3904 17.5205 20.4219 17.5949 20.4219 17.6719C20.4219 17.7489 20.3904 17.8233 20.3344 17.8784L16.0469 22.0469' stroke='#747D87' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'></path></svg></button>",
        swipe: true
    });

    var currentSlideIndex = 0;
    var _slideIndex = 0;
    var $slickEl = $('.shopify-section--video-slider .video_slider');
    const isVideoPlaying = video => !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    const isVideoMediaPlaying = videoMedia => !!videoMedia.playing;

    // Set preferred slidesToShow
    var slidesToShow = 7; 
    
    // Clone the slides.
    var $slides = $('.shopify-section--video-slider .video_slider .video-slider_slide');
    slidesToShow = Math.min(slidesToShow, $slides.length);
    if ($slides.length <= slidesToShow)
      slidesToShow = (slidesToShow - 1) <= 0 ? 1 : (slidesToShow - 1);
    //if (slidesToShow % 2 === 0) 
      //slidesToShow = (slidesToShow - 1) <= 0 ? 1 : (slidesToShow - 1);

    function playVideo(video) {
        if (video) {
            pauseAllVideos();
            if (!video.playing) {
                video.play()
            }
        }
    }

    function pauseAllVideos() {
        console.log("Pause")
        $('.video_slider .video-slider_slide .content-over-media').find("video-media").each(function() {
            isVideoMediaPlaying(this) && this.pause()
        });
    }
    $slickEl.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        currentSlideIndex = currentSlide;
        pauseAllVideos();
    });

    // $slickEl.on('afterChange', function(event, slick, currentSlide) {
    //     if (currentSlideIndex !== currentSlide) {
    //         let activeSlide = $(slick.$slides.get(currentSlide));
    //         playVideo($(activeSlide).find("video-media")[0]);
    //     }
    // });

    $(document).on("click", ".button_play", function(e) {
        let videoMedia = $(this).closest(".video-slider_slide").find("video-media");

        if (videoMedia && videoMedia[0]) {
            playVideo(videoMedia[0])
        }
    })
    if($slickEl.data('variable-width')) {
      var $variableWidth = $slickEl.data('variable-width');
    } else {
      var $variableWidth = false;
    }
    $slickEl.slick({
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: slidesToShow, // Ensures multiple small slides are visible alongside the large one
        focusOnSelect: true,
        infinite: true, // Allows infinite looping
        adaptiveHeight: true,
        arrows: true,
        dots: false,
        variableWidth: true,
        prevArrow: "<button type='button' class='slick-prev pull-left video-slider-nav-btn'><svg width='35' height='36' viewBox='0 0 35 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M18.9531 13.2969L14.6656 17.4654C14.6096 17.5205 14.5781 17.5949 14.5781 17.6719C14.5781 17.7489 14.6096 17.8233 14.6656 17.8784L18.9531 22.0469' stroke='#747D87' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'></path></svg></button>",
        nextArrow: "<button type='button' class='slick-next pull-right video-slider-nav-btn'><svg width='35' height='36' viewBox='0 0 35 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16.0469 13.2969L20.3344 17.4654C20.3904 17.5205 20.4219 17.5949 20.4219 17.6719C20.4219 17.7489 20.3904 17.8233 20.3344 17.8784L16.0469 22.0469' stroke='#747D87' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'></path></svg></button>",
        responsive: [{
                breakpoint: 1600,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '0px',
                    adaptiveHeight: true,
                    slidesToShow: slidesToShow
                }
            },
            {
                breakpoint: 1500,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '0px',
                    adaptiveHeight: true,
                    slidesToShow: slidesToShow
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '0px',
                    adaptiveHeight: true,
                    slidesToShow: (slidesToShow - 2) <= 0 ? 1 : (slidesToShow - 2)
                }
            },
            {
                breakpoint: 1250,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '0px',
                    adaptiveHeight: true,
                    slidesToShow: (slidesToShow - 4) <= 0 ? 1 : (slidesToShow - 4)
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                    centerMode: true,
                    centerPadding: '0px',
                    adaptiveHeight: true,
                    slidesToShow: (slidesToShow - 4) <= 0 ? 1 : (slidesToShow - 4)
                }
            },
            {
                breakpoint: 769,
                settings: "unslick"
            }
        ]
    });


   $(".team-members").slick({
        slidesToShow: 6.5,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
       responsive: [  
         {
            breakpoint: 1400,
             settings: { 
              slidesToShow: 4.5,
               slidesToScroll: 1
            }
          },
           {
            breakpoint: 1200,
             settings: { 
              slidesToShow: 3.5,
               slidesToScroll: 1
            }
          },
         {
            breakpoint: 999,
             settings: { 
              slidesToShow: 3.2,
               slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: "unslick"
          }
        ]
    });


$(".team-btn-wrap .prev-btn").click(function () {
		$(".team-members").slick("slickPrev");
	});

	$(".team-btn-wrap .next-btn").click(function () {
		$(".team-members").slick("slickNext");
	});
	$(".team-btn-wrap .prev-btn").addClass("slick-disabled");
	$(".team-btn-wrap").on("afterChange", function () {
		if ($(".slick-prev").hasClass("slick-disabled")) {
			$(".team-btn-wrap .prev-btn").addClass("slick-disabled");
		} else {
			$(".team-btn-wrap .prev-btn").removeClass("slick-disabled");
		}
		if ($(".slick-next").hasClass("slick-disabled")) {
			$(".team-btn-wrap .next-btn").addClass("slick-disabled");
		} else {
			$(".team-btn-wrap .next-btn").removeClass("slick-disabled");
		}
	});
  

});

document.addEventListener("DOMContentLoaded", (event) => {
    const alternateProducts = () => {
        let isDown = false;
        let startX;
        let scrollLeft;
        const alternateProducts = document.querySelector('.shopify-section--multi-column-events multi-column.multi-column');

        if (!alternateProducts) {
            return;
        }
        const end = () => {
            isDown = false;
        }

        const start = (e) => {
            isDown = true;
            startX = e.pageX || e.touches[0].pageX - alternateProducts.offsetLeft;
            scrollLeft = alternateProducts.scrollLeft;
        }

        const move = (e) => {
            if (!isDown) return;

            e.preventDefault();
            const x = e.pageX || e.touches[0].pageX - alternateProducts.offsetLeft;
            const dist = (x - startX) * 2;
            // Smooth scrolling using requestAnimationFrame
            requestAnimationFrame(() => {
                alternateProducts.scrollLeft = scrollLeft - dist;
            });
        }

        alternateProducts.addEventListener('mousedown', start);
        alternateProducts.addEventListener('touchstart', start);

        alternateProducts.addEventListener('mousemove', move);
        alternateProducts.addEventListener('touchmove', move);

        alternateProducts.addEventListener('mouseleave', end);
        alternateProducts.addEventListener('mouseup', end);
        alternateProducts.addEventListener('touchend', end);

    }
    // Init free gifts slider
    let matchMedia = window.matchMedia("(min-width:767px)");
    if (matchMedia.matches) {
        alternateProducts();
    }
});

$(function() {
    $(".event_button_wrapper button").click(function() {
        $(this).parents().parents().siblings(".event_popup_video_wrapper").fadeIn("50");
        $("body").addClass("video_visible");
    })
    $(".event_popup_video_wrapper,.event_popup_video_close,.event_popup_video").click(function() {
        $(".event_popup_video_wrapper").fadeOut("50");
        $("body").removeClass("video_visible");
    })
    $(".event_popup_video_wrapper .event_popup_video_inner").click(function(e) {
        e.stopPropagation();
    })
})

$(function() {
    $(".header__secondary-nav button#toggle_menu_button").click(function() {
        $("body").toggleClass("show_menu");
    })

})

$(document).ready(function() {
    $(document).on("click", ".toggle_submenu", function(e) {
        $(this).closest("li.has_submenu").find(".header-sidebar__linklist").slideToggle();
        $(this).toggleClass("show");
    });

    $(document).on("click", ".footer_menu_toggle", function(e) {

        $(this).closest("div.footer_menu").find(".slide_link_wrapper").slideToggle();
        $(this).toggleClass("show");
    });

    $(".collection_showAll_button_wrapper button").click(function() {
        $(this).hide();
        $(".collection.limited_productShow").hide();
        $(".collection.all_productShow").show();

    });

    $('.shopify-section-packages-products .packages_product_item_list product-card.product-card:nth-child(1)').addClass('active');
    $('.shopify-section-packages-products .packages_product_item_list product-card.product-card').click(function() {
        $(this).addClass('active').closest('.shopify-section-packages-products .packages_product_item_list product-card.product-card').siblings('.shopify-section-packages-products .packages_product_item_list product-card.product-card').removeClass('active');
        // return false;
    });

//     $('.video_badge .badge_content').slick({
//         slidesToScroll: 1,
//       slidesToShow: 1,
//       adaptiveHeight: true,
//         arrows: false,
//         dots: false,
//         vertical: true,
//         verticalSwiping: true,
//         autoplay: true,
//       infinite: true,
//       focusOnSelect: true,
//         autoplaySpeed: 2500
//     });
//   $('.video_badge .badge_content').on('afterChange', function(event, slick) {
//     $('.slick-track').css('transform', 'none');
// });
  
});


const slider = document.querySelector('.slider');
const slides = Array.from(document.querySelectorAll('.slide'));

let currentIndex = 1; // Start from the first cloned slide
const totalSlides = slides.length;
const slideHeight = slides[0]?.offsetHeight; // Get height of each slide
const intervalTime = 3000; // Auto-scroll interval in milliseconds

// Clone first and last slides
const firstClone = slides[0]?.cloneNode(true);
const lastClone = slides[slides.length - 1]?.cloneNode(true);
slider?.appendChild(firstClone); // Add first slide clone to the end
slider?.insertBefore(lastClone, slides[0]); // Add last slide clone to the beginning

// Update the slider's initial position to the first real slide
if(slider){
  slider.style.transform = `translateY(-${slideHeight}px)`;
}


// Function to update slide position
function updateSlidePosition() {
  if(slider){
        slider.style.transition = 'transform 0.5s ease';
    slider.style.transform = `translateY(-${currentIndex * slideHeight}px)`;
  }

}

// Function to handle the infinite scroll effect
function autoScroll() {
    currentIndex++;
    updateSlidePosition();

    // Reset position when reaching the clones
    if (currentIndex === totalSlides + 1) {
        setTimeout(() => {
            slider.style.transition = 'none'; // Disable transition for the jump
            currentIndex = 1; // Reset to the first actual slide
            slider.style.transform = `translateY(-${slideHeight}px)`;
        }, 500); // Wait for the transition to complete
    } else if (currentIndex === 0) {
        setTimeout(() => {
            slider.style.transition = 'none'; // Disable transition for the jump
            currentIndex = totalSlides; // Reset to the last actual slide
            slider.style.transform = `translateY(-${totalSlides * slideHeight}px)`;
        }, 500); // Wait for the transition to complete
    }
}

// Start the auto-scroll interval
setInterval(autoScroll, intervalTime);

// Initialize to the first real slide position
updateSlidePosition();





// Update cart count 

document.addEventListener('DOMContentLoaded', function() {
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartDot = document.getElementsByClassName('header__cart-dot')[0];
        if (cartDot) {
          cartDot.innerText = cart.item_count;
        }
      });
  }

  updateCartCount();
  setInterval(updateCartCount, 4000); 
});



// Show related product in cart



$(".all-related-products").slick({
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
       responsive: [          
           {
            breakpoint: 990,
             settings: { 
              slidesToShow: 2,
               slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: "unslick"
          }
        ]
    });

    $(".arrow-btn-wrap .prev-btn").click(function() {
        $(".all-related-products").slick("slickPrev");
    });

    $(".arrow-btn-wrap .next-btn").click(function() {
        $(".all-related-products").slick("slickNext");
    });
    $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
    $(".all-related-products").on("afterChange", function() {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .prev-btn").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .next-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .next-btn").removeClass("slick-disabled");
        }
    });



// document.addEventListener('DOMContentLoaded', function() {
//     fetch('/cart.js')
//         .then(response => response.ok ? response.json() : null)
//         .then(cart => {
//             if (!cart || !cart.items || cart.items.length === 0) return;

//             const firstLineItem = cart.items[0]; 
//             const productHandle = firstLineItem.handle;

//             if (productHandle) {
//                 fetch(`/products/${productHandle}.json`)
//                     .then(response => response.ok ? response.json() : null)
//                     .then(data => {
//                         const product = data ? data.product : null;
//                         const tags = product && typeof product.tags === 'string' ? product.tags.split(',').map(tag => tag.trim()) : [];

//                         if (tags.length > 0) {
//                             fetch(`/products.json?tags=${encodeURIComponent(tags.join(','))}`)
//                                 .then(response => response.ok ? response.json() : null)
//                                 .then(productsData => {
//                                     const relatedProducts = productsData ? productsData.products : [];
//                                     const filteredProducts = relatedProducts.filter(p => p.handle !== productHandle);
                                    
//                                     if (filteredProducts.length > 0) {
//                                         displayProduct(filteredProducts[0]);
//                                     }
//                                 });
//                         }
//                     });
//             }
//         });

//     function displayProduct(product) {
//        if(document.getElementById('related-product-container')){
//            document.getElementById('related-product-container').innerHTML = `
//             <h4 class="related-product-heading related-heading">Related Products</h4>
//             <div class="single-related-product">
//             <a href="/products/${product.handle}">
//                 <img src="${product.images[0]?.src || ''}" alt="${product.title}">
//             </a>
//             </div>
//         `;
//        }
      
//     }
// });

// document.addEventListener('DOMContentLoaded', function() {
//     fetch('/cart.js')
//         .then(response => {
//             if (!response.ok) throw new Error('Network response was not ok while fetching cart.');
//             return response.json();
//         })
//         .then(cart => {
//             if (!cart.items || cart.items.length === 0) {
//                 console.warn('Cart is empty.');
//                 return;
//             }

//             const firstLineItem = cart.items[0]; 
//             const productHandle = firstLineItem.handle;

//             if (productHandle) {
//                 fetch(`/products/${productHandle}.json`)
//                     .then(response => {
//                         if (!response.ok) {
//                             throw new Error('Error fetching product details.');
//                         }
//                         return response.json();
//                     })
//                     .then(data => {
//                         const product = data.product;
//                         // console.log('Product Details:', product);

//                         const tags = typeof product.tags === 'string' ? product.tags.split(',').map(tag => tag.trim()) : [];
//                         // console.log('Product Tags:', tags);

//                         if (tags.length > 0) {
//                             fetch(`/products.json?tags=${encodeURIComponent(tags.join(','))}`)
//                                 .then(response => {
//                                     if (!response.ok) {
//                                         throw new Error('Error fetching products by tags.');
//                                     }
//                                     return response.json();
//                                 })
//                                 .then(productsData => {
//                                     const relatedProducts = productsData.products;

//                                     const filteredProducts = relatedProducts.filter(p => p.handle !== productHandle);
                                    
//                                     if (filteredProducts.length > 0) {
//                                         const relatedProduct = filteredProducts[0]; 
//                                         displayProduct(relatedProduct);
//                                     } else {
//                                         console.warn('No related products found with matching tags.');
//                                     }
//                                 })
//                                 .catch(error => console.error('Error fetching products by tags:', error));
//                         } else {
//                             console.warn('No tags found for the product.');
//                         }
//                     })
//                     .catch(error => console.error('Error fetching product details:', error));
//             } else {
//                 console.warn('No valid product handle found in the first line item.');
//             }
//         })
//         .catch(error => console.error('Error fetching cart data:', error));

//     function displayProduct(product) {
//         const container = document.getElementById('related-product-container');
//         container.innerHTML = `
//             <h4 class="related-product-heading related-heading">Related Products</h4>
//             <div class="single-related-product">
//             <a href="/products/${product.handle}">
//                 <img src="${product.images[0]?.src || ''}" alt="${product.title}">
//             </a>
//             </div>
//         `;
//     }
// });




$(document).ready(function(){


  // Trigger cart-breadcrumb checkout button

  
  $(".cart_checkout_button").click(function(){
    $("#Checkout_Button").trigger("click");
  });

$(".service-watch-video").click(function(){
  $(".service-video-section").show();
  $("body").addClass('video-plyaing');
});
  $(".video-poup-close").click(function(){
    $(".service-video-section").hide();
  $("body").removeClass('video-plyaing');
  });
  
});



document.querySelector(".packages_product_item_list")?.querySelectorAll("input[data-variant-id]").forEach(input => {

    input.addEventListener("change", e => {

        let $form = e.target.closest("product-card").querySelector("form");
        if($form && $form.length && $form.querySelector("[name=id]")){

          $form.querySelector("[name=id]").value = parseInt(e.target.dataset.variantId, 10);
        }
    });
});




  $(document).ready(function(){

$(".buy_it_product_item_list").slick({
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
       responsive: [          
           {
            breakpoint: 990,
             settings: { 
              slidesToShow: 2,
               slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: "unslick"
          }
        ]
    });

    $(".arrow-btn-wrap .prev-btn").click(function() {
        $(".buy_it_product_item_list").slick("slickPrev");
    });

    $(".arrow-btn-wrap .next-btn").click(function() {
        $(".buy_it_product_item_list").slick("slickNext");
    });
    $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
    $(".buy_it_product_item_list").on("afterChange", function() {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .prev-btn").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .next-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .next-btn").removeClass("slick-disabled");
        }
    });
  });

 $(document).ready(function(){

$(".blog-video-post-wrapper").slick({
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
       responsive: [          
           {
            breakpoint: 990,
             settings: { 
              slidesToShow: 2,
               slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: "unslick"
          }
        ]
    });

    $(".arrow-btn-wrap .prev-btn").click(function() {
        $(".blog-video-post-wrapper").slick("slickPrev");
    });

    $(".arrow-btn-wrap .next-btn").click(function() {
        $(".blog-video-post-wrapper").slick("slickNext");
    });
    $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
    $(".blog-video-post-wrapper").on("afterChange", function() {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .prev-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .prev-btn").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".arrow-btn-wrap .next-btn").addClass("slick-disabled");
        } else {
            $(".arrow-btn-wrap .next-btn").removeClass("slick-disabled");
        }
    });


     // Disable add to cart button according to variant


$(".is-disabled").click(function() {
  // $(this).closest(".product-card").find(".product-card__quick-add-button").attr('disabled', 'disabled');
  $(this).closest(".product-card").find(".not-available-card-button").show();
  $(this).closest(".product-card").find(".available-card-button").hide();
});

$(".not-disabled").click(function() {
  // $(this).closest(".product-card").find(".product-card__quick-add-button").removeAttr('disabled');
  $(this).closest(".product-card").find(".not-available-card-button").hide();
  $(this).closest(".product-card").find(".available-card-button").show();
});





     // Change the Selected Vraint Image on variant click on Collection Page

$(".product-card  .color-swatch ").click(function(){
  $(this).prev().trigger('click');
});


$(".shopify-section--text-with-icons .text-with-icons__item.ChatWithUs").click(function(){
  window.GorgiasChat.open();
});


var main_product_price = parseInt($(".main-product-title-price-image-section").attr('data-main-price'));
var support_product_price = parseInt($(".package-include-block").attr('support-price'));
var AI_product_price = parseInt($(".cloud-ai-confimation-btn").attr('ai-price'));
var Total_price = '';  
var formatted_price = ''; 
var store_currency = document.querySelector("body").dataset.moneyFormat;
   
$(".support-package-block .toggle-switch .Exclude-Package").click(function() {
  var main_product_price = parseInt($(".main-product-title-price-image-section").attr('data-main-price'));
 $(".all-iclude-features .support-feature").hide(); 
  if ($(".include-ai").is(":checked")) {
    var Total_price = main_product_price + AI_product_price;
  }else{
    var Total_price = main_product_price ;
  }
  var formatted_price = store_currency.replace('{{amount}}', (Total_price / 100).toFixed(2));
  $(".main-product-title-price-image-section .money-with-currency").text(formatted_price);
});

   
$(".support-package-block .toggle-switch .Include-Package").click(function() {
  var main_product_price = parseInt($(".main-product-title-price-image-section").attr('data-main-price'));
 $(".all-iclude-features .support-feature").show();
  if ($(".include-ai").is(":checked")) {
    var Total_price = main_product_price + AI_product_price + support_product_price;
  }else{
    var Total_price = main_product_price + support_product_price;
  }
  var formatted_price = store_currency.replace('{{amount}}', (Total_price / 100).toFixed(2));
  $(".main-product-title-price-image-section .money-with-currency").text(formatted_price);
});

   
$(".cloud-ai-confimation-btn .exclude-ai").click(function(){
  var main_product_price = parseInt($(".main-product-title-price-image-section").attr('data-main-price'));
  $(".all-iclude-features .cloud-feature").hide();
  $(".cloud-details-block").hide();
  if ($(".Include-Package").is(":checked")) {
     var Total_price = main_product_price + support_product_price;
  }else{
    var Total_price = main_product_price ;
  }
    var formatted_price = store_currency.replace('{{amount}}', (Total_price / 100).toFixed(2));
  $(".main-product-title-price-image-section .money-with-currency").text(formatted_price);
});


$(".cloud-ai-confimation-btn .include-ai").click(function(){
  var main_product_price = parseInt($(".main-product-title-price-image-section").attr('data-main-price'));
 $(".all-iclude-features .cloud-feature").show();
   $(".cloud-details-block").show();
  if ($(".Include-Package").is(":checked")) {
     var Total_price = main_product_price + AI_product_price + support_product_price;
  }else{
    var Total_price = main_product_price + AI_product_price;
  }
  var formatted_price = store_currency.replace('{{amount}}', (Total_price / 100).toFixed(2));
  $(".main-product-title-price-image-section .money-with-currency").text(formatted_price);
});

   

$(".plan-change-AI").change(function(){
  
  var Variant_price =  parseInt($(this).attr('data-variant-price'));
  $(".main-product-title-price-image-section").attr('data-main-price',Variant_price);
  var Variant_title = $(this).attr('data-plan');
  if ($(".include-ai").is(":checked") || $(".Include-Package").is(":checked") ) {
    var Total_price = Variant_price + main_product_price + support_product_price;
  }else if ($(".include-ai").is(":checked") || !$(".Include-Package").is(":checked") ){
    var Total_price = Variant_price + main_product_price;
  }else if (!$(".include-ai").is(":checked") || $(".Include-Package").is(":checked") ){
    var Total_price = Variant_price + main_product_price;
  }else{
     var Total_price = Variant_price;
  }
  var formatted_price = store_currency.replace('{{amount}}', (Total_price / 100).toFixed(2));
  var Set_Variant_price =  store_currency.replace('{{amount}}', (Variant_price / 100).toFixed(2));
  $(".main-product-title-price-image-section .money-with-currency").text(formatted_price);
  $(".all-iclude-features .cloud-feature .cloud_selected_price").text(Set_Variant_price);
  $(".all-iclude-features .cloud-feature .cloud_selected_title").text(Variant_title);
  


  var Variant_id = $(this).attr('value');
  $(".single-variant-plan .plan-selector").each(function(){
    var Plan_id = $(this).attr('data-plan-id');
    if(Variant_id == Plan_id){
      $(this).text('Selected');
    }else{
      $(this).text('Select Plan');
    }
  });
});   

$(".single-variant-plan .plan-selector").click(function() {
  $(".single-variant-plan .plan-selector").text('Select Plan');
  $(this).text('Selected');
  var Plan_selector_id = $(this).attr('data-plan-id');
  $(".plan-change-AI").each(function() {
    var plan_Change_AI_ID = $(this).val(); 
    if (Plan_selector_id === plan_Change_AI_ID) {
      $(this).trigger('click'); 
    }
  });
});
 
});

window.checkNewSalesChat = async function checkNewSalesChat(email) {
  const endpointUrl = 'https://command.fotomaster.com/shopify/chat_check.php';
  try {
    const response = await fetch(endpointUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    if (data.status === 'success') {
      // Return both the `isNewSalesChat` boolean and the `shopify_customer_id`
      return {
        isNewSalesChat: data.isNewSalesChat,
        shopifyCustomerId: data.shopify_customer_id || null
      };
    } else {
      console.error("Error from server:", data.message);
      return { isNewSalesChat: false, shopifyCustomerId: null };
    }
  } catch (error) {
    console.error("Error occurred while calling the endpoint:", error);
    return { isNewSalesChat: false, shopifyCustomerId: null };
  }
};

window.updateInteractionOnShopify = async function updateInteractionOnShopify(shopifyCustomerId, utmData) {
  const endpointUrl = 'https://command.fotomaster.com/shopify/customer_interaction.php';
  
  try {
    const response = await fetch(endpointUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      // Now we send `customer_id` instead of email
      body: JSON.stringify({ customer_id: shopifyCustomerId, utm_data: utmData })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    if (data.status === 'success') {
      console.log("Interaction updated successfully");
    } else {
      console.error("Error from server:", data.message);
    }
  } catch (error) {
    console.error("Error occurred while updating the interaction:", error);
  }
};

window.getUTMData = async function() {
  // Read from localStorage if the URL doesn't have UTM parameters
  const urlParams = new URLSearchParams(window.location.search);
  const utmKeys = [
    'utm_source','utm_medium','utm_campaign',
    'utm_term','utm_content','utm_id'
  ];

  // Fallback to localStorage if needed
  utmKeys.forEach(key => {
    if (!urlParams.get(key)) {
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        urlParams.set(key, storedValue);
      }
    }
  });

  const isMobile = /Mobi|Android|iPhone|iPad|iPod|Windows Phone|BlackBerry|Opera Mini/i.test(navigator.userAgent);
  const deviceType = isMobile ? "Mobile" : "Desktop";

  const referrer = document.referrer || "Direct";
  const landingPage = window.location.href;
  const timestamp = new Date().toISOString();

  // Parse cookies
  const parseCookies = () => {
    return document.cookie.split(';').reduce((acc, cookie) => {
      const [key, value] = cookie.split('=').map(c => c.trim());
      if (key && value) {
        acc[key] = value;
      }
      return acc;
    }, {});
  };
  const cookies = parseCookies();

  // Facebook cookies
  const fbp = cookies['_fbp'] || null;
  const fbc = cookies['_fbc'] || null;

  // GA cookies
  const gaCookie = cookies['_ga'];
  const gaUserId = gaCookie ? `${gaCookie.split('.')[2]}.${gaCookie.split('.')[3]}` : null;
  const gaSessionKey = Object.keys(cookies).find(key => /^_ga_[A-Z0-9]+$/.test(key));
  const gaSessionId = gaSessionKey && cookies[gaSessionKey]
    ? cookies[gaSessionKey].split('.').slice(-1)[0]
    : null;

  const msclkid = urlParams.get('msclkid') || null;

  try {
    // Fetch client IP
    const ipResponse = await fetch('https://api64.ipify.org?format=json');
    const ipData = await ipResponse.json();
    const clientIP = ipData.ip;

    return {
      // UTM parameters
      utm_source: urlParams.get('utm_source'),
      utm_medium: urlParams.get('utm_medium'),
      utm_campaign: urlParams.get('utm_campaign'),
      utm_id: urlParams.get('utm_id'),
      utm_term: urlParams.get('utm_term'),
      utm_content: urlParams.get('utm_content'),

      // Traffic source details
      search_term: urlParams.get('utm_term'),
      ad_group_name: urlParams.get('utm_adgroup'),
      ad_name: urlParams.get('utm_ad'),
      campaign_identifier: urlParams.get('utm_campaign'),
      ad_identifier: urlParams.get('utm_ad_identifier'),
      ad_group_identifier: urlParams.get('utm_adgroup_identifier'),

      // Landing page metadata
      landing_page_url: landingPage,

      // Referrer metadata
      referrer_name: referrer,
      medium_codename: urlParams.get('utm_medium'),

      // Facebook metadata
      fbp: fbp,
      fbc: fbc,

      // Google Analytics identifiers
      ga_user_id: gaUserId,
      ga_session_id: gaSessionId,

      // Bing
      msclkid: msclkid,

      // Client details
      client_user_agent: navigator.userAgent,
      device_type: deviceType,
      client_ip: clientIP,

      // Timestamp
      timestamp: timestamp
    };
  } catch (error) {
    console.error("Error fetching UTM data or client IP:", error);
    return {
      referrer: referrer,
      landing_page: landingPage,
      timestamp: timestamp,
      fbp: fbp,
      fbc: fbc,
      ga_user_id: gaUserId,
      ga_session_id: gaSessionId
    };
  }
};

window.loadScript = function(url) {
    return new Promise((resolve, reject) => {
        // Check if the script is already loaded
        if (document.querySelector(`script[src="${url}"]`)) {
            return resolve();
        }
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
        document.head.appendChild(script);
    });
};

window.loadPhoneLibraries = async function() {
    if (!window.phoneLibraryUrls) {
        console.error("Phone library URLs are not defined.");
        return;
    }

    try {
        await loadScript(window.phoneLibraryUrls.libphonenumber);
        await loadScript(window.phoneLibraryUrls.phoneFormatter);
        console.log("Phone libraries loaded successfully.");
    } catch (error) {
        console.error(error.message);
    }
};








